import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class ValidSportResolver implements Resolve<boolean> {
  constructor(private _common: CommonService, private _route: Router) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    let configuration = this._common.configuration.getValue();
    let index = this._common.sports.indexOf(route.paramMap.get('sport'));
    if (index !== -1) {
      return of(configuration.sports[index].value);
    }
    this._route.navigate(['/']);
    return of(false);
  }
}
